import Model from '@/app/Model'
import { Module } from '@/models/Module'

export class Plan extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			price: 0,
			default: false
		}
	}
	static hasMany () {
		return {
			modules: Module
		}
	}
}

export function createPlan (data) {
	return Object.freeze(new Plan(data))
}
